import React, {
  useCallback,
  useMemo,
} from 'react'
import {
  FormField, Box, Text, IcoMoon, CloseIcon,
} from '@usap/uicomponents'
import {
  BoxWithPointer,
} from '@usap/widgets'
import TextInputWithEllipsis from './TextInputWithEllipsis'

const InputText = params => {
  const {
    label,
    id,
    name,
    type,
    value,
    error,
    placeholder,
    onChange,
    onBlur,
    disabled = false,
    ariaLabel,
  } = params

  const style = useMemo(
    () => ({
      wrapperBorder: { color: error ? 'status-critical' : 'dark-4' },
      wrapperPosition: { position: 'relative' },
      closeButton: {
        boxShadow: 'none',
        position: 'absolute',
        top: 8,
        right: 8,
        height: 24,
      },
      wrapperError: { display: 'block' },
    }),
    [error],
  )

  const resetClick = useCallback(
    () => {
      onChange({
        target: {
          name,
          value: '',
        },
      })
    },
    [onChange, name],
  )

  const onBlurFun = useCallback(
    event => {
      if (onBlur) {
        onBlur(event.target.name)
      }
    },
    [onBlur],
  )

  const onKeyPressFun = useCallback(
    event => {
      if (type === 'number') {
        const { charCode } = event
        if (charCode > 31 && (charCode < 48 || charCode > 57)) event.preventDefault()
      }
    },
    [type],
  )

  return (
    <FormField label={label} htmlFor={id}>
      <Box
        background="white"
        round="xsmall"
        border={style.wrapperBorder}
        style={style.wrapperPosition}
      >
        <TextInputWithEllipsis
          plain
          id={id}
          type={type}
          name={name}
          aria-label={ariaLabel}
          size="small"
          onChange={onChange}
          value={value}
          placeholder={placeholder}
          onBlur={onBlurFun}
          disabled={disabled}
          onKeyPress={onKeyPressFun}
        />
        {value && (
          <BoxWithPointer
            height="24px"
            style={style.closeButton}
            onClick={resetClick}
          >
            <IcoMoon
              icon={CloseIcon}
              size="24px"
              color={error ? 'status-critical' : 'dark-4'}
            />
          </BoxWithPointer>
        )}
      </Box>
      <Text
        style={style.wrapperError}
        color="status-critical"
        size="xsmall"
      >
        {error}
      </Text>
    </FormField>
  )
}

export default InputText
